import {
  NOTIFICATION_NEW,
  READNOTIFICATION
} from "../../constants/ActionTypes";

const INIT_STATE = {
  notifications: JSON.parse(localStorage.getItem('bms-notifications') || '{}')
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case NOTIFICATION_NEW: {
      const newNotifications = {
        ...state.notifications,
        [action.email]: [action.payload, ...(state.notifications[action.email] || [])]
      };

      console.log('newNotifications', newNotifications);
      localStorage.setItem('bms-notifications', JSON.stringify(newNotifications));

      return {
        ...state,
        notifications: newNotifications
      }
    }

    case READNOTIFICATION: {
      console.log('action.payload', action.payload);
      console.log('not', state.notifications[action.payload.email]);
      const newNotifications = state.notifications;
      const notification = state.notifications[action.payload.email][action.payload.id];
      notification.read = true;
      newNotifications[action.payload.email][action.payload.id] = notification;

      console.log('newNotifications', newNotifications);
      localStorage.setItem('bms-notifications', JSON.stringify(newNotifications));

      return {
        ...state,
        notifications: newNotifications
      }
    }

    default:
      return state;
  }
}
